import {
  ChartBarIcon,
  Squares2X2Icon,
  RectangleGroupIcon,
  ArrowLeftEndOnRectangleIcon,
  DocumentIcon,
} from '@heroicons/react/24/outline';
import i18n from '../config/i18n';
import { IRoute } from '../interfaces/route.interface';
import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/20/solid';

export const ROUTES_CLIENT = (clientId: string): IRoute[] => {
  return [
    {
      id: 1,
      name: i18n.t('side_menu:back_clients'),
      href: 'clients',
      icon: ArrowLeftStartOnRectangleIcon,
      lineAfter: true,
    },
    {
      id: 2,
      name: i18n.t('side_menu:requests'),
      href: `clients/${clientId}/requests`,
      icon: RectangleGroupIcon,
    },
    {
      id: 3,
      name: 'Cereri comune',
      href: `clients/${clientId}/common`,
      icon: Squares2X2Icon,
    },
  ];
};

export const ADMIN_ROUTES_CLIENT = (clientId: string): IRoute[] => {
  return [
    {
      id: 1,
      name: i18n.t('side_menu:back_clients'),
      href: 'clients',
      icon: ArrowLeftStartOnRectangleIcon,
      lineAfter: true,
    },
    {
      id: 2,
      name: i18n.t('side_menu:requests'),
      href: `clients/${clientId}/requests`,
      icon: RectangleGroupIcon,
    },
    {
      id: 3,
      name: 'Cereri comune',
      href: `clients/${clientId}/common`,
      icon: Squares2X2Icon,
    },
    {
      id: 4,
      name: 'Setari adeverinta',
      href: `clients/${clientId}/certificate`,
      icon: DocumentIcon,
    },
    {
      id: 5,
      name: 'Setari anexa',
      href: `clients/${clientId}/annex`,
      icon: DocumentIcon,
    },
  ];
};

export const ROUTES: IRoute[] = [
  {
    id: 1,
    name: i18n.t('side_menu:dashboard'),
    href: 'dashboard',
    icon: ChartBarIcon,
  },
  {
    id: 2,
    name: i18n.t('side_menu:clients'),
    href: 'clients',
    icon: RectangleGroupIcon,
  },
  {
    id: 3,
    name: i18n.t('side_menu:users'),
    href: 'users',
    icon: Squares2X2Icon,
  },
];

export const EMPLOYEE_ROUTES: IRoute[] = [
  {
    id: 1,
    name: i18n.t('side_menu:clients'),
    href: '',
    icon: RectangleGroupIcon,
  },
];

export const SUPER_ADMIN_COMPANY_ROUTES = (companyId: string): IRoute[] => [
  {
    id: 1,
    name: i18n.t('side_menu:back_companies'),
    href: 'companies',
    icon: ArrowLeftEndOnRectangleIcon,
    lineAfter: true,
  },
  {
    id: 2,
    name: i18n.t('side_menu:dashboard'),
    href: `companies/${companyId}/dashboard`,
    icon: ChartBarIcon,
  },
  {
    id: 3,
    name: i18n.t('side_menu:clients'),
    href: `companies/${companyId}/clients`,
    icon: RectangleGroupIcon,
  },
  {
    id: 4,
    name: i18n.t('side_menu:users'),
    href: `companies/${companyId}/users`,
    icon: Squares2X2Icon,
  },
];

export const SUPER_ADMIN_COMPANY_CLIENT_ROUTES = (companyId: string, clientId: string) => {
  return [
    {
      id: 1,
      name: i18n.t('side_menu:back_companies'),
      href: 'companies',
      icon: ArrowLeftEndOnRectangleIcon,
      lineAfter: true,
    },
    {
      id: 2,
      name: i18n.t('side_menu:back_clients'),
      href: `companies/${companyId}/clients`,
      icon: ArrowLeftStartOnRectangleIcon,
      lineAfter: true,
    },
    {
      id: 3,
      name: i18n.t('side_menu:requests'),
      href: `companies/${companyId}/clients/${clientId}/requests`,
      icon: RectangleGroupIcon,
    },
    {
      id: 4,
      name: i18n.t('side_menu:common_requests'),
      href: `companies/${companyId}/clients/${clientId}/common`,
      icon: Squares2X2Icon,
    },
    {
      id: 5,
      name: 'Setari adeverinta',
      href: `companies/${companyId}/clients/${clientId}/certificate`,
      icon: DocumentIcon,
    },
    {
      id: 6,
      name: 'Setari anexa',
      href: `companies/${companyId}/clients/${clientId}/annex`,
      icon: DocumentIcon,
    },
  ];
};

export const SUPER_ADMIN_ROUTES: IRoute[] = [
  {
    id: 0,
    name: i18n.t('side_menu:dashboard'),
    href: 'dashboard',
    icon: ChartBarIcon,
  },
  {
    id: 1,
    name: i18n.t('side_menu:companies'),
    href: 'companies',
    icon: RectangleGroupIcon,
  },
];
